import type { GatsbyBrowser } from 'gatsby'


let scrollResetFrame: number | undefined

const cancelScrollReset = () => {
    if (scrollResetFrame !== undefined) {
        window.cancelAnimationFrame(scrollResetFrame)
        scrollResetFrame = undefined
    }
}


export const onPreRouteUpdate: GatsbyBrowser['onPreRouteUpdate'] = () => {
    cancelScrollReset()
}

export const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = ({ location, prevLocation }) => {
    cancelScrollReset()

    // Gatsby adds Reach Router's history action at runtime, but omits it from its types.
    const { action } = location as Location & { action?: string }
    if (action !== 'PUSH' || !prevLocation || prevLocation.pathname === location.pathname || location.hash) return

    // Reapply Gatsby's top reset after the new page has painted. Mobile Chrome
    // can otherwise retain an offset when navigating from far down the old page.
    scrollResetFrame = window.requestAnimationFrame(() => {
        scrollResetFrame = window.requestAnimationFrame(() => {
            scrollResetFrame = undefined
            window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
        })
    })
}
